import { computed, type Ref } from 'vue';
import { getTransactionReferenceDetails } from '@peanuds/shared';
import type { Transaction } from '@peanuds/shared-state';

import { mapTransactionToTableRow } from '../internal/control-spendings-table.adapter';
import {
  appendControlSpendingSearchText,
  filterControlSpendingTableRows,
} from '../internal/control-spendings-table.filters';
import type { ControlSpendingsTableFilter } from '../internal/control-spendings-table.types';

type UseControlSpendingsTableRowsOptions = {
  transactions: Ref<readonly Transaction[]>;
  filter: () => ControlSpendingsTableFilter;
  search: () => string;
};

export const useControlSpendingsTableRows = ({
  transactions,
  filter,
  search,
}: UseControlSpendingsTableRowsOptions) => {
  const rows = computed(() => {
    return transactions.value.map((transaction, index) => {
      return appendControlSpendingSearchText(mapTransactionToTableRow(transaction, index));
    });
  });

  const filteredRows = computed(() => {
    return filterControlSpendingTableRows(rows.value, {
      filter: filter(),
      search: search(),
    });
  });

  const totalRecords = computed(() => filteredRows.value.length);

  const hasReferenceDetails = computed(() => {
    return filteredRows.value.some((row) => getTransactionReferenceDetails(row).length > 0);
  });

  return {
    rows,
    filteredRows,
    totalRecords,
    hasReferenceDetails,
  };
};
